export default __webpack_public_path__ + "assets/images/af955b7553de71526ed4fe102a689d53.png";